import DialogComponent from './component'
import { commonRenderProps } from '../common/props'

export default (context, dialogName: string, dialogContextOpts: object, additionalOptions: object = {}) => {
  
  const dialogContext  = {
    onSuccess: () => {},
    onCancel: () => {},
    onCustomEvent: (_eventName: string) => {},
    onClose: () => {},
    size: 'md',
    ...dialogContextOpts,
  }
  
  const url = import.meta.env.VITE_VUE_URL + '/#/dialog/' + dialogName

  const dialog = DialogComponent({
    ...commonRenderProps({ context, dialogContext }),

    url,

    size: dialogContext.size,

    handleCloseDialog: async (frame, uid) => {
      if (frame && uid) {
        frame.contentWindow.postMessage(
          {
            name: 'onClose',
            uid,
          },
          url,
        )
      }
      dialogContext.onClose()
      setTimeout(() => {
        dialog.close()
      }, 100)
    },

    emitDialogSuccess: () => {
      dialogContext.onSuccess()
      dialogContext.onClose()
      setTimeout(() => {
        dialog.close()
      }, 100)
    },

    emitDialogCancel: () => {
      dialogContext.onCancel()
      dialogContext.onClose()
      setTimeout(() => {
        dialog.close()
      }, 100)
    },

    emitCustomEvent: (eventName: string, closeAfter = true) => {
      dialogContext.onCustomEvent(eventName)
      if (closeAfter) {
        dialogContext.onClose()
        setTimeout(() => {
          dialog.close()
        }, 100)
      }
    },
    ...additionalOptions
  })

  dialog.render('body')

  return dialog
}
